"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ESCAPE_VELOCITY_THRESHOLD = exports.DATA_VALUE = exports.SEED_VALUE = exports.MAXIMUM_LOGISTICS_RATE = exports.MAXIMUM_MINING_RATE = exports.MAXIMUM_HABITAT_RATE = exports.MAXIMUM_MOON_RATE = exports.TERRA_CIMMERIA_COLONY_COST = exports.VASTITAS_BOREALIS_NOVA_BONUS_TEMPERATURE_COST = exports.VASTITAS_BOREALIS_BONUS_TEMPERATURE_COST = exports.HELLAS_BONUS_OCEAN_COST = exports.GRAPHENE_VALUE = exports.CEO_CARDS_DEALT_PER_PLAYER = exports.PRELUDE_CARDS_DEALT_PER_PLAYER = exports.POLITICAL_AGENDAS_MAX_ACTION_USES = exports.REDS_RULING_POLICY_COST = exports.DELEGATES_FOR_NEUTRAL_PLAYER = exports.DELEGATES_PER_PLAYER = exports.TITANIUM_TRADE_COST = exports.ENERGY_TRADE_COST = exports.MC_TRADE_COST = exports.MAX_FLEET_SIZE = exports.MAX_COLONIES_PER_TILE = exports.MAX_COLONY_TRACK_POSITION = exports.TEMPERATURE_BONUS_FOR_HEAT_2 = exports.TEMPERATURE_BONUS_FOR_HEAT_1 = exports.ALT_VENUS_MINIMUM_BONUS = exports.VENUS_LEVEL_FOR_TR_BONUS = exports.VENUS_LEVEL_FOR_CARD_BONUS = exports.TEMPERATURE_FOR_OCEAN_BONUS = exports.OXYGEN_LEVEL_FOR_TEMPERATURE_BONUS = exports.MAX_VENUS_SCALE = exports.MIN_VENUS_SCALE = exports.MIN_OXYGEN_LEVEL = exports.MIN_TEMPERATURE = exports.MAX_OXYGEN_LEVEL = exports.MAX_TEMPERATURE = exports.MAX_OCEAN_TILES = exports.HEAT_FOR_TEMPERATURE = exports.CORPORATION_CARDS_DEALT_PER_PLAYER = exports.OCEAN_BONUS = exports.MICROBES_VALUE = exports.FLOATERS_VALUE = exports.DEFAULT_TITANIUM_VALUE = exports.DEFAULT_STEEL_VALUE = exports.MAX_AWARDS = exports.AWARD_COSTS = exports.MAX_MILESTONES = exports.MILESTONE_COST = exports.CARD_COST = void 0;
exports.DEFAULT_URL_ROOT = exports.DEFAULT_LOG_LENGTH = exports.DEFAULT_WAITING_FOR_TIMEOUT = exports.DISCORD_INVITE = exports.APP_NAME = exports.LANGUAGES = exports.ALL_LANGUAGES = exports.ASIMOV_AWARD_BONUS = exports.BONUS_SECONDS_PER_ACTION = exports.DEFAULT_ESCAPE_VELOCITY_PENALTY = exports.DEFAULT_ESCAPE_VELOCITY_PERIOD = exports.DEFAULT_ESCAPE_VELOCITY_BONUS_SECONDS = void 0;
exports.CARD_COST = 3;
exports.MILESTONE_COST = 8;
exports.MAX_MILESTONES = 3;
exports.AWARD_COSTS = [8, 14, 20];
exports.MAX_AWARDS = 3;
exports.DEFAULT_STEEL_VALUE = 2;
exports.DEFAULT_TITANIUM_VALUE = 3;
exports.FLOATERS_VALUE = 3;
exports.MICROBES_VALUE = 2;
exports.OCEAN_BONUS = 2;
exports.CORPORATION_CARDS_DEALT_PER_PLAYER = 2;
exports.HEAT_FOR_TEMPERATURE = 8;
exports.MAX_OCEAN_TILES = 9;
exports.MAX_TEMPERATURE = 8;
exports.MAX_OXYGEN_LEVEL = 14;
exports.MIN_TEMPERATURE = -30;
exports.MIN_OXYGEN_LEVEL = 0;
exports.MIN_VENUS_SCALE = 0;
exports.MAX_VENUS_SCALE = 30;
exports.OXYGEN_LEVEL_FOR_TEMPERATURE_BONUS = 8;
exports.TEMPERATURE_FOR_OCEAN_BONUS = 0;
exports.VENUS_LEVEL_FOR_CARD_BONUS = 8;
exports.VENUS_LEVEL_FOR_TR_BONUS = 16;
exports.ALT_VENUS_MINIMUM_BONUS = 16;
exports.TEMPERATURE_BONUS_FOR_HEAT_1 = -24;
exports.TEMPERATURE_BONUS_FOR_HEAT_2 = -20;
exports.MAX_COLONY_TRACK_POSITION = 6;
exports.MAX_COLONIES_PER_TILE = 3;
exports.MAX_FLEET_SIZE = 4;
exports.MC_TRADE_COST = 9;
exports.ENERGY_TRADE_COST = 3;
exports.TITANIUM_TRADE_COST = 3;
exports.DELEGATES_PER_PLAYER = 7;
exports.DELEGATES_FOR_NEUTRAL_PLAYER = 14;
exports.REDS_RULING_POLICY_COST = 3;
exports.POLITICAL_AGENDAS_MAX_ACTION_USES = 3;
exports.PRELUDE_CARDS_DEALT_PER_PLAYER = 4;
exports.CEO_CARDS_DEALT_PER_PLAYER = 3;
exports.GRAPHENE_VALUE = 4;
exports.HELLAS_BONUS_OCEAN_COST = 6;
exports.VASTITAS_BOREALIS_BONUS_TEMPERATURE_COST = 3;
exports.VASTITAS_BOREALIS_NOVA_BONUS_TEMPERATURE_COST = 4;
exports.TERRA_CIMMERIA_COLONY_COST = 5;
exports.MAXIMUM_MOON_RATE = 8;
exports.MAXIMUM_HABITAT_RATE = 8;
exports.MAXIMUM_MINING_RATE = 8;
exports.MAXIMUM_LOGISTICS_RATE = 8;
exports.SEED_VALUE = 5;
exports.DATA_VALUE = 3;
exports.DEFAULT_ESCAPE_VELOCITY_THRESHOLD = 30;
exports.DEFAULT_ESCAPE_VELOCITY_BONUS_SECONDS = 2;
exports.DEFAULT_ESCAPE_VELOCITY_PERIOD = 2;
exports.DEFAULT_ESCAPE_VELOCITY_PENALTY = 1;
exports.BONUS_SECONDS_PER_ACTION = 5;
exports.ASIMOV_AWARD_BONUS = 2;
exports.ALL_LANGUAGES = ['en', 'de', 'fr', 'ru', 'cn', 'pl', 'es', 'br', 'it', 'ko', 'nl', 'hu', 'jp', 'bg', 'nb', 'ua', 'fi'];
exports.LANGUAGES = {
    en: ['English', 'English'],
    de: ['Deutsch', 'German'],
    fr: ['Français', 'French'],
    ru: ['Русский', 'Russian'],
    cn: ['华语', 'Chinese'],
    pl: ['Polski', 'Polish'],
    es: ['Español', 'Spanish'],
    br: ['Português Brasileiro', 'Brazilian Portugese'],
    it: ['Italiano', 'Italian'],
    ko: ['한국어', 'Korean'],
    nl: ['Nederlands', 'Dutch'],
    hu: ['Magyar', 'Hungarian'],
    jp: ['日本語', 'Japanese'],
    bg: ['Български', 'Bulgarian'],
    nb: ['Norsk', 'Norwegian'],
    ua: ['Українська', 'Ukrainian'],
    fi: ['Suomi', 'Finnish'],
};
exports.APP_NAME = 'Terraforming Mars';
exports.DISCORD_INVITE = 'https://discord.gg/afeyggbN6Y';
exports.DEFAULT_WAITING_FOR_TIMEOUT = 1000;
exports.DEFAULT_LOG_LENGTH = 50;
exports.DEFAULT_URL_ROOT = 'http://localhost:8080';
